import { render, staticRenderFns } from "./Participants.vue?vue&type=template&id=afcc68f6&lang=pug"
import script from "./Participants.vue?vue&type=script&lang=js"
export * from "./Participants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports